import { guardTranslatedDomMutations } from '@utils/dom/guardTranslatedDomMutations';

// Runs before hydration, so the guard is in place before React's first commit.
guardTranslatedDomMutations();
